import {c, t} from 'ttag';
import {Option} from 'types';

import {ApprovalGroup, ApproverValue} from './types';

export const parser = (approverOptions: ApprovalGroup[]) => ({
    options: (): Option[] => {
        const _users = approverOptions.filter((option) => option.personalTeam);
        const _groups = approverOptions.filter(
            (option) => !option.personalTeam,
        );
        let options: Option[] = _users.map((user) => ({
            hidden: user.revoked,
            label: user.name,
            value: user.mid,
        }));
        if (_groups.length > 0) {
            options.push({
                disabled: true,
                label: t`Groups`,
                value: '',
            });
            options = options.concat(
                _groups.map((group) => ({
                    label: group.name,
                    value: group.mid,
                })),
            );
        }
        return options;
    },
});
export const checkers = (data: ApproverValue[]) => {
    return {
        hasNext: (index: number): boolean => {
            return index < data.length - 1;
        },
        hasPrevious: (index: number): boolean => {
            return index > 0;
        },
    };
};
export const validator = (value: ApproverValue | undefined) => {
    return {
        hasSameApproverSeveralTimesInARow: (
            currentIndex: number,
            allValues: ApproverValue[],
        ): string | void => {
            const errorMessage = c('component')
                .t`You can not add the same approver several times in a row`;
            if (currentIndex > 0) {
                const previousValue = allValues[currentIndex - 1];
                if (value === previousValue) return errorMessage;
            }
            if (currentIndex < allValues.length - 1) {
                const nextValue = allValues[currentIndex + 1];
                if (value === nextValue) return errorMessage;
            }
        },
        isDefined: (): string | void => {
            if (value === undefined || value === null)
                return t`Please complete this required field.`;
        },
        isUsingRevokedUser: (options: ApprovalGroup[]): string | void => {
            const option = options.find((o) => o.mid === value);
            if (option && option.revoked) return c('component').t`User revoked`;
        },
    };
};
